/**
 * jQuery thumbnail rotator
 *
 */
jQuery.rotator = {
	attach: function () {
		$('img.rotator').on('mouseenter touchstart', function () {
			var img = $(this);

			img.urls = img.data('urls').trim().split(' ');
			img.count = img.urls.length;
			img.data('default_url', img.attr('src'));

			jQuery.rotator.show(img, 0);
			jQuery.rotator.timer = setInterval(function () {
				jQuery.rotator.cycle(img);
			}, 500);
		});

		$('img.rotator').on('mouseleave touchend', function () {
			var img = $(this);

			clearInterval(jQuery.rotator.timer);
			jQuery.rotator.show(img, null);
		});
	},

	cycle: function (img) {
		var index = (img.index + 1) % img.count;

		jQuery.rotator.show(img, index);
	},

	show: function (img, index) {
		if (index != null) {
			img.index = index;
			img.attr('src', img.urls[img.index]);
		} else {
			img.attr('src', img.data('default_url'));
		}
	},

	timer: null
};

/**
 * jQuery Scene Switcher
 *
 */
jQuery.sceneSwitcher = {
	_player: null,
	_scenes: [],

	init: function (markers, config) {
		var previous_scene = null;
		var switcher = this;

		// init instance
		this._player = config.player;

		// loop through markers
		for (var i = 1; i <= markers.length - 1; i++) {
			// create a clickable segment element
			var _el = $('<div/>', {
				class: config.sceneClass
			}).appendTo(config.scenesContainer);
			// create scene object
			var scene = {
				start: markers[i - 1],
				end: markers[i],
				next: null,
				prev: null,
				el: _el
			};
			// link element to scene
			this.hookClick(_el, scene);
			// stitch scenes together
			previous_scene = previous_scene || scene;
			scene.prev = previous_scene;
			previous_scene.next = scene;
			// get ready for the next round
			previous_scene = scene;
			// append scene to the list
			this._scenes.push(scene);
		}

		// update progress bar
		this._updateProgressBar();

		// hook on timeupdate event
		this._player.on('timeupdate', function () {
			switcher._updateProgressBar();
		});

		return this;
	},

	currentScene: function () {
		var current_time = this._player.currentTime();
		var current_scene = this._scenes.find(function (scene) {
			return scene.start <= current_time && current_time <= scene.end;
		});

		// current cannot be found
		if (typeof current_scene === 'undefined') {
			throw new RangeError('current scene undefined');
		}

		return current_scene;
	},

	hookClick: function (el, scene) {
		var switcher = this;

		el.click(function () {
			switcher.seek(scene);
		});
	},

	seek: function (scene) {
		this._player.currentTime(scene.start);
		this._player.play();
	},

	seekNext: function () {
		try {
			var current_scene = this.currentScene();

			if (current_scene.next != null) {
				this.seek(current_scene.next);
			}
		} catch (err) {
			// error
		}
	},

	seekPrev: function () {
		try {
			var current_scene = this.currentScene();

			this.seek(current_scene.prev);
		} catch (err) {
			// error
		}
	},

	_updateProgressBar: function () {
		try {
			var current_scene = this.currentScene();
			var current_time = this._player.currentTime();
			var progress = Math.round(
				((current_time - current_scene.start) / (current_scene.end - current_scene.start)) * 100
			);

			// reset all
			this._scenes.forEach(function (scene) {
				scene.el.removeClass('current');
				scene.el.removeAttr('style');
			});
			// set the current segment
			current_scene.el.addClass('current');
			current_scene.el.attr('style', '--progress: ' + progress + '%');
		} catch (err) {
			// error
		}
	}
};

/**
 * jQuery Scroll Lock function
 *
 */
$.scrollLock = (function scrollLockClosure() {
	'use strict';

	var $html = $('html'),
		// State: unlocked by default
		locked = false,
		// State: scroll to revert to
		prevScroll = {
			scrollLeft: $(window).scrollLeft(),
			scrollTop: $(window).scrollTop()
		},
		// State: styles to revert to
		prevStyles = {},
		lockStyles = {
			'overflow-y': 'scroll',
			position: 'fixed',
			width: '100%'
		};

	// Instantiate cache in case someone tries to unlock before locking
	saveStyles();

	// Save context's inline styles in cache
	function saveStyles() {
		var styleAttr = $html.attr('style'),
			styleStrs = [],
			styleHash = {};

		if (!styleAttr) {
			return;
		}

		styleStrs = styleAttr.split(/;\s/);

		$.each(styleStrs, function serializeStyleProp(styleString) {
			if (typeof styleString !== 'string' || !styleString) {
				return;
			}

			var keyValue = styleString.split(/\s:\s/);

			if (keyValue.length < 2) {
				return;
			}

			styleHash[keyValue[0]] = keyValue[1];
		});

		$.extend(prevStyles, styleHash);
	}

	function lock() {
		var appliedLock = {};

		// Duplicate execution will break DOM statefulness
		if (locked) {
			return;
		}

		// Save scroll state...
		prevScroll = {
			scrollLeft: $(window).scrollLeft(),
			scrollTop: $(window).scrollTop()
		};

		// ...and styles
		saveStyles();

		// Compose our applied CSS
		$.extend(appliedLock, lockStyles, {
			// And apply scroll state as styles
			left: -prevScroll.scrollLeft + 'px'
			// 'top'  : - prevScroll.scrollTop  + 'px'
		});

		// Then lock styles...
		$html.css(appliedLock);

		// ...and scroll state
		$(window).scrollLeft(0).scrollTop(0);

		locked = true;
	}

	function unlock() {
		// Duplicate execution will break DOM statefulness
		if (!locked) {
			return;
		}

		// Revert styles
		$html.attr('style', $('<x>').css(prevStyles).attr('style') || '');

		// Revert scroll values
		$(window).scrollLeft(prevScroll.scrollLeft).scrollTop(prevScroll.scrollTop);

		locked = false;
	}

	return function scrollLock(on) {
		// If an argument is passed, lock or unlock depending on truthiness
		if (arguments.length) {
			if (on) {
				lock();
			} else {
				unlock();
			}
		}
		// Otherwise, toggle
		else {
			if (locked) {
				unlock();
			} else {
				lock();
			}
		}
	};
})();

jQuery.initExitLinks = function () {
	$('a.exit').each(function (i) {
		const url = new URL(this.href);
		if (this.href.startsWith('http') && url.hostname !== document.domain) {
			this.href = updateUrlParameter(this.href, jQuery.adult._cookie_name, 'true');

			let preferenceCookie = getCookie('preference');
			if (preferenceCookie) {
				let preferences = preferenceCookie.split('-');
				let firstLetters = preferences.map(word => word[0]);
				this.href = updateUrlParameter(this.href, 'preference', firstLetters.join(''));
			}

			let token = document.body.getAttribute('data-token');
			if (token) {
				this.href = updateUrlParameter(this.href, 'token', token);
			}
			
			let ref = getCookie('ref');
			if (ref) {
				this.href = updateUrlParameter(this.href, 'ref', ref);
			}
		}
	});

	function updateUrlParameter(url, paramName, paramValue) {
		let parsedUrl = new URL(url, window.location.origin);
		parsedUrl.searchParams.set(paramName, paramValue);
		return parsedUrl.href;
	}
};

/**
 * jQuery Adult Content plugin
 *
 */
jQuery.adult = {
	_cookie_name: 'adult_content_agreement',

	init: function () {
		jQuery.adult.modal();
	},

	modal: function () {
		const adultContentAgreement =
			$.cookie(jQuery.adult._cookie_name) ||
			$.url.getvar(jQuery.adult._cookie_name) ||
			location.href.includes(jQuery.adult._cookie_name);
		const adultContentModal = $.url.getvar('adult_content_modal');
		const oneTimePass = $.url.getvar('one_time_pass');
		const modal = $('.modal[data-modal-type="age-restriction"]');

		// Function to close modal
		function closeModal() {
			jQuery.adult.agreed();
			modal.toggleClass('active');
		}

		if (adultContentAgreement || adultContentModal) {
			jQuery.adult.agreed();

			let trackerId = $('body').data('gtag-tracker');
			window.loadGoogleTagManager(trackerId);
		}

		// Show the Adult Content Warning modal ...
		if (!adultContentAgreement && !adultContentModal) {
			modal.toggleClass('active');
			modal.focus();

			if (oneTimePass) {
				modal.toggleClass('active');
				return;
			}

		}

		// Listeners for closing modal
		$(document).on('click', '.modal__button--enter', event => {
			jQuery.adult.setPreference(modal, (includeAll = true));
			jQuery.adult.agreed();
			modal.toggleClass('active');
		});

		$(document).on('click', '.modal__button--save', event => {
			jQuery.adult.setPreference(modal);
			jQuery.adult.agreed();
			modal.toggleClass('active');
		});

		$(document).on('click', '.modal__button--change', event => {
			event.stopPropagation();
			modal.addClass('change');
		});

		$(document).on('click', '.modal__button--back', event => {
			event.stopPropagation();
			modal.removeClass('change');
		});

		$(document).on('click', '[data-clickable="false"]', event => {
			event.preventDefault();
		});

		modal.on('keydown', function (e) {
			if (e.which === 13 || e.which === 27) {
				// Enter or ESC
				jQuery.adult.setPreference(modal, (includeAll = true));
				jQuery.adult.agreed();
				modal.toggleClass('active');
			}
		});

		$('.modal__button--leave').on('click', function () {
			window.location.href = 'https://duckduckgo.com/';
		});

		$('.internal-link').on('click', function (event) {
			event.preventDefault();
			var redirectUrl = this.href;
			window.location.href = redirectUrl + '?one_time_pass=true';
		});
	},

	agreed: function () {
		let cookie_domain = '.' + document.domain.replace('www.', '');
		let expiry = new Date();

		// ... for a prolonged period of time! :-(
		expiry.toUTCString(expiry.setTime(expiry.getTime() + 7 * 24 * 3600 * 1000));

		$.cookie(jQuery.adult._cookie_name, true, {
			domain: cookie_domain,
			path: '/',
			expires: expiry
		});

		localStorage.setItem('agreement', 'true');
		document.body.classList.remove('blur');

		$(document).trigger('playHpSlider');
	},
	setPreference: function (modal, includeAll = false) {
		let cookie_domain = '.' + document.domain.replace('www.', '');
		let expiry = new Date();

		expiry.toUTCString(expiry.setTime(expiry.getTime() + 7 * 24 * 3600 * 1000));

		let names = [];
		let inputs;

		// Determine which inputs to include based on the includeAll flag
		if (includeAll) {
			inputs = modal.find('input');
		} else {
			inputs = modal.find('input:checked');
		}

		inputs.each(function () {
			names.push($(this).attr('name'));
		});

		let preferenceValue = names.join('-');

		// Manually set the cookie to avoid URL encoding
		document.cookie =
			'preference=' + preferenceValue + '; domain=' + cookie_domain + '; path=/; expires=' + expiry.toUTCString();
	}
};

/**
 * jQuery .zip downloader
 *
 */
jQuery.zippy = {
	_collect: function (urls, zip, options) {
		var url = urls[0];
		var remaining_urls = urls.slice(1);

		JSZipUtils.getBinaryContent(url, function (err, data) {
			var filename = url.match(/[a-zA-Z0-9\-\_]+\.(jpg|png|gif|svg)/g);

			if (err) {
				throw err;
			}

			zip.file(filename, data, {
				binary: true
			});

			options.progressed(url);

			if (remaining_urls.length > 0) {
				jQuery.zippy._collect(remaining_urls, zip, options);
			} else {
				options.done(zip);
			}
		});
	},

	_zip: function (filename, zip) {
		zip.generateAsync({ type: 'blob' }).then(function (content) {
			saveAs(content, filename);
		});
	},

	download: function (urls, filename, options) {
		var zip = new JSZip();

		options = jQuery.extend({}, options);

		if (!JSZip.support.blob) {
			alert('This downloader works only with a recent browser!');
			return;
		}

		jQuery.zippy._collect(urls, zip, {
			progressed: function (url) {
				if (options.progressed) options.progressed(url);
			},
			done: function (zip) {
				jQuery.zippy._zip(filename, zip);

				if (options.done) options.done(filename);
			}
		});
	}
};

/**
 * jQuery URL plugin
 *
 */
jQuery.url = {
	append: function (url, param, value) {
		var val = param + '=' + value;

		if (url.indexOf('?') >= 0) {
			url += '&' + val;
		} else {
			url += '?' + val;
		}

		return url;
	},

	getvars: function () {
		var hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var vars = [];

		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}

		return vars;
	},

	getvar: function (name) {
		return jQuery.url.getvars()[name];
	}
};

/**
 * jQuery Cookie plugin
 *
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * https://github.com/carhartl/jquery-cookie
 *
 */
jQuery.cookie = function (key, value, options) {
	// key and at least value given, set cookie...
	if (arguments.length > 1 && String(value) !== '[object Object]') {
		options = jQuery.extend({}, options);

		if (value === null || value === undefined) {
			options.expires = -1;
		}

		if (typeof options.expires === 'number') {
			var days = options.expires,
				t = (options.expires = new Date());

			t.setDate(t.getDate() + days);
		}

		value = String(value);

		return (document.cookie = [
			encodeURIComponent(key),
			'=',
			options.raw ? value : encodeURIComponent(value),
			options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
			options.path ? '; path=' + options.path : '',
			options.domain ? '; domain=' + options.domain : '',
			options.secure ? '; secure' : ''
		].join(''));
	}

	// key and possibly options given, get cookie...
	options = value || {};
	var result,
		decode = options.raw
			? function (s) {
					return s;
			  }
			: decodeURIComponent;

	return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie))
		? decode(result[1])
		: null;
};

/**
 * jQuery Video Thumbnail plugin
 *
 */
// TODO: redo into minimal optimized own solution
jQuery.videoThumbnail = {
	selector: '.thumbnail_wrapper:has(img.vthumb)',
	clsPlaying: 'vthumb-playing',

	init: function () {
		this.attach($(this.selector));
	},

	attach: function (element) {
		$(element).on('touchstart', function (e) {
			if (!$.videoThumbnail.playing($(this))) {
				$($.videoThumbnail.selector + ' video').each(function () {
					$.videoThumbnail.hide($(this).parent());
				});
				$.videoThumbnail.show($(this));
			}
		});

		$(element).on('mouseenter', function () {
			$.videoThumbnail.show($(this));
		});

		$(element).on('mouseleave', function () {
			$.videoThumbnail.hide($(this));
		});
	},

	show: function (element) {
		let imgElement = element.find('img'),
			thumbnailURL = imgElement.attr('data-thumbnail');
		let altText = imgElement.attr('alt');

		// show show-stoppers
		if (!thumbnailURL || this.playing(element)) {
			return;
		}

		// remove any existing video
		element.find('video').remove();

		element.addClass(this.clsPlaying);

		element.append(
			'<video style="display: none" class="preview__video" muted loop playsinline><source src="' +
				thumbnailURL +
				'" type="video/mp4"></video>'
		);

		let videoElement = element.find('video'),
			video = videoElement.get(0);

		videoElement.fadeIn(300, function () {
			if (video.paused) {
				video.play();
			}
		});
	},

	hide: function (element) {
		var videoElement = element.find('video'),
			imgElement = element.find('img');

		if (this.playing(element)) {
			element.removeClass(this.clsPlaying);

			imgElement.fadeIn(500, function () {
				$(this).show();
			});

			videoElement.fadeOut(500, function () {
				$(this).remove();
			});
		}
	},

	playing: function (element) {
		return element.hasClass(this.clsPlaying);
	}
};


/**
 * jQuery Countdown Timer
 */
jQuery.countdown = {
    init: function() {
        const $countdown = $('.js-offer-countdown');
        
        if ($countdown.length) {
            let storedTime = localStorage.getItem('countdownTime');
            let initialMinutes, initialSeconds;
            let minutes, seconds;

            if (storedTime) {
                [minutes, seconds] = storedTime.split(':').map(Number);
            } else {
                const timeString = $countdown.text().split(':');
                initialMinutes = parseInt(timeString[0]) || 0;
                initialSeconds = parseInt(timeString[1]) || 10;
                minutes = initialMinutes;
                seconds = initialSeconds;
            }

            const timer = setInterval(function() {
                if (minutes === 0 && seconds === 0) {
                    // Reset to initial values to restart the countdown
                    minutes = initialMinutes;
                    seconds = initialSeconds;
                } else {
                    if (seconds === 0) {
                        minutes--;
                        seconds = 59;
                    } else {
                        seconds--;
                    }
                }
                
                $countdown.text(
                    ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
                );

                // Store the current time
                localStorage.setItem('countdownTime', `${minutes}:${seconds}`);
            }, 1000);
        }
    }
};

/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 *
 * jQuery.browser.mobile will be true if the browser is a mobile device
 *
 **/
(function (a) {
	(jQuery.browser = jQuery.browser || {}).mobile =
		/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
			a
		) ||
		/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
			a.substr(0, 4)
		);
})(navigator.userAgent || navigator.vendor || window.opera);
